
import { AppService } from "app/services/app.service";
import { PlanilhaDto } from "app/models/planilha-dto.model";
import { Observable } from "rxjs";

export abstract class AbPlanilha extends AppService {
  abstract savePlanilha(planilha: PlanilhaDto): Observable<any>;
  abstract getResumo();
  abstract existeRegistrosBase();
  abstract existeUsuariosCadastrados();
  abstract criarUsuario();
  abstract reintegrar();
}
